import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { UserService } from '../shared/services/user-service';
import { environment } from '../environments/environment';

export const permissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const userService = inject(UserService); // Use inject() to get the service
  const router = inject(Router); // Use inject() to get the Router
  const companyApiBaseUrl = environment.companyApiBaseUrl; // Get the company URL from environment variables
  // Get the route path and parameters
  const currentRoute = route.routeConfig?.path;
  const id = +route.params['id']; // Convert the ID parameter to a number
  const user = userService.getUserFromLocalStorage();
  let requiredPermission = route.data['permission'];

  //  ;/
  if (user) {
    // Default to using the permission defined in route data

    // Dynamic permission logic for specific routes
    if (requiredPermission == 'General') {
      return true; // Allow access for general permission
    }

    switch (currentRoute) {
      case 'builder/:id':
        requiredPermission = id === 0 ? 'Template:Create' : 'Template:Update';
        break;
      case 'add-posting-profile/:id':
        requiredPermission =
          id === 0 ? 'PostingProfile:Create' : 'PostingProfile:Update';
        break;
      case 'add-carrier/:id':
        requiredPermission = id === 0 ? 'Carrier:Create' : 'Carrier:Update';
        break;
    }

    return userService
      .getUserRolesandPerm()
      .then((permissions) => {
        const hasPermission = permissions.some(
          (permission) => permission.name === requiredPermission
        );
        if (hasPermission) {
          return true; // Allow access
        } else {
          router.navigate(['']); // Redirect if no permission
          return false;
        }
      })
      .catch((error) => {
        console.error('Error fetching permissions:', error);
        router.navigate(['']); // Redirect on error
        return false;
      });
  } else {
    const returnUrl = encodeURIComponent(window.location.href);
    window.location.replace(
      `${environment.companyWebBaseUrl}/login?redirectTo=${returnUrl}`
    );
    return false; // Redirect to login if user is not authenticated
  }
};
